"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReference = createReference;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
/**
 * Create a reference doc under `loom/refs/` as `{slug}-reference.md`. Shared by the
 * MCP tool and the CLI so both surfaces write byte-identical files (parity). A
 * trailing "reference" word in the title is stripped so "API Reference" → api-reference.md
 * (not api-reference-reference.md). Reference docs are born at status "active" — no
 * draft gate. Pass `content` to write the body; omit for a placeholder.
 */
async function createReference(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const { title } = input;
    const description = input.description ?? '';
    const providedContent = input.content;
    const id = (0, dist_1.generateDocId)('reference');
    const rawSlug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const slug = (0, dist_1.stripTrailingTypeWord)(rawSlug, 'reference');
    const refsDir = path.join(loomRoot, 'loom', 'refs');
    await deps.fs.ensureDir(refsDir);
    const today = (0, dist_1.today)();
    const filePath = path.join(refsDir, `${slug}-reference.md`);
    const lines = [
        '---',
        'type: reference',
        `id: ${id}`,
        `title: "${title}"`,
        'status: active',
        `created: ${today}`,
        'version: 1',
        'tags: []',
        'parent_id: null',
        'child_ids: []',
        'requires_load: []',
        `slug: ${slug}`,
        ...(description ? [`description: "${description}"`] : []),
        '---',
        '',
    ];
    const body = providedContent
        ? (providedContent.endsWith('\n') ? providedContent : `${providedContent}\n`)
        : `# ${title}\n\n${description ? `${description}\n\n` : ''}<!-- Add reference content here -->\n`;
    await deps.fs.writeFile(filePath, lines.join('\n') + body, 'utf8');
    return { id, filePath, slug };
}
